import { FC, useState, useEffect } from "react";
import "./delete.css";
import Swal from "sweetalert2";
import { useAppConfig } from "../../../hooks/useAppConfig";

const Delete: FC = () => {
  const [termo, setTermo] = useState(false);

  // Buscar a cor primária para o link dos termos
  const { getAppConfig } = useAppConfig();
  const [primaryColor, setPrimaryColor] = useState("#078BD8");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const conf = await getAppConfig();
        if (conf?.webappcolor?.webappbutton) {
          setPrimaryColor(conf.webappcolor.webappbutton);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchConfig();
  }, []);

  const solicitar = async () => {
    // Validação de segurança extra (apesar do botão já ficar desabilitado)
    if (!termo) {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Você precisa confirmar que está ciente das informações marcando a caixa de seleção.",
        confirmButtonColor: primaryColor,
      });
      return;
    }

    // Colocar a chamada da API de exclusão aqui.
    Swal.fire({
      icon: "success",
      title: "Solicitação enviada",
      text: "Sua solicitação de exclusão foi encaminhada ao time de suporte e será processada.",
      confirmButtonColor: primaryColor,
    });
  };

  return (
    <div className="perfil-delete-content">
      <div className="perfil-delete-header">
        <h2>Excluir conta</h2>
      </div>

      <span className="perfil-delete-text">
        Ao cancelar o seu cadastro no sistema, você vai perder acesso a
        informações, pedidos e funcionalidades. Sem o cadastro, você não terá
        mais acesso às suas informações pessoais armazenadas na conta e também
        perderá todos os benefícios associados à mesma. Além disso, você não
        será mais capaz de realizar compras nem acompanhar compras anteriores.
        Certifique-se de avaliar todas as consequências possíveis para evitar
        arrependimentos futuros.
        <br />
        <br />
        A sua solicitação será encaminhada ao time de suporte que irá processar
        o pedido em até 2 dias úteis. Você receberá uma notificação quando a
        conta for excluída.
        <br />
        <br />
        Mesmo com a exclusão da conta no sistema, informações pessoais poderão
        ficar armazenadas no histórico de pedidos e transações comerciais. Para
        saber mais, acesse os{" "}
        <button style={{ color: primaryColor }}>termos de uso</button> do
        sistema.
      </span>

      {/* Checkbox de Confirmação */}
      <div className="perfil-delete-checkbox-group">
        <input
          type="checkbox"
          checked={termo}
          onChange={(event) => setTermo(event.target.checked)}
        />
        <span>
          Estou ciente das informações e desejo solicitar a exclusão da minha
          conta.
        </span>
      </div>

      {/* Botão destrutivo: Fica cinza se não marcar, fica vermelho se marcar */}
      <button
        className="perfil-delete-btn"
        style={{ background: termo ? "#E11D48" : undefined }}
        disabled={!termo}
        onClick={() => solicitar()}
      >
        Solicitar exclusão
      </button>
    </div>
  );
};

export { Delete };
